"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";

const _interactionsData = JSON.parse(
  '{"events":{"e":{"id":"e","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-4"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"13d79344-ebcb-e42a-9e0a-ca3e760a9bf2","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"13d79344-ebcb-e42a-9e0a-ca3e760a9bf2","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1701565477262},"e-2":{"id":"e-2","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-2","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-3"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"13d79344-ebcb-e42a-9e0a-ca3e760a9bf2","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"13d79344-ebcb-e42a-9e0a-ca3e760a9bf2","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1701565477262}},"actionLists":{"a":{"id":"a","title":"Hero Card - on - hover","actionItemGroups":[{"actionItems":[{"id":"a-n","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"13d79344-ebcb-e42a-9e0a-ca3e760a9bf2"},"globalSwatchId":"","rValue":46,"bValue":46,"gValue":46,"aValue":1}}]},{"actionItems":[{"id":"a-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"inOutQuad","duration":100,"target":{"useEventTarget":true,"id":"13d79344-ebcb-e42a-9e0a-ca3e760a9bf2"},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":1}}]}],"useFirstGroupAsInitialState":true,"createdOn":1701565487896},"a-2":{"id":"a-2","title":"Hero Card - on - hover 2","actionItemGroups":[{"actionItems":[{"id":"a-2-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"inOutQuad","duration":100,"target":{"useEventTarget":true,"id":"13d79344-ebcb-e42a-9e0a-ca3e760a9bf2"},"globalSwatchId":"","rValue":46,"bValue":46,"gValue":46,"aValue":1}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701565487896}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function HeroSubCardComponent({
  as: _Component = _Builtin.Block,
  title = "Careers",

  link = {
    href: "#",
  },

  description = "Schedule rent payments, submit maintenance requests, renew your lease and more.",
  icon = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/656bd2a03bf3058f0b5261d9_residents.svg",
  ctaText = "Join Our Team →",
  linkText = "Locations",

  linkLink = {
    href: "#",
  },
}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <_Component className="subhero-card-component" tag="div">
      <_Builtin.Block
        className="subhero-card"
        data-w-id="13d79344-ebcb-e42a-9e0a-ca3e760a9bf2"
        tag="div"
      >
        <_Builtin.Block className="subhero-card-copy-block" tag="div">
          <_Builtin.Block className="subhero-card-inside" tag="div">
            <_Builtin.Block tag="div">
              <_Builtin.Block
                className="subhero-card---title-and-logo"
                tag="div"
              >
                <_Builtin.Block className="icon-wrapper" tag="div">
                  <_Builtin.Image
                    className="icon-1x1-medium"
                    loading="lazy"
                    width="48"
                    height="48"
                    src={icon}
                  />
                </_Builtin.Block>
                <_Builtin.Block className="title" tag="div">
                  {title}
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block className="subhero-card-descritpion" tag="div">
                <_Builtin.Block
                  className="subhero-card---description"
                  tag="div"
                >
                  {description}
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Link
              className="button is-icon"
              button={false}
              block="inline"
              options={linkLink}
            >
              <_Builtin.Block tag="div">{linkText}</_Builtin.Block>
              <_Builtin.HtmlEmbed
                className="icon-embed-xsmall"
                value="%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20aria-hidden%3D%22true%22%20role%3D%22img%22%20class%3D%22iconify%20iconify--heroicons%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20preserveaspectratio%3D%22xMidYMid%20meet%22%20viewbox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22none%22%20stroke%3D%22currentColor%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20d%3D%22M17.25%208.25L21%2012m0%200l-3.75%203.75M21%2012H3%22%2F%3E%3C%2Fsvg%3E"
              />
            </_Builtin.Link>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
